import { d as s, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as t, createElementBlock as c, normalizeClass as n, normalizeStyle as r, createElementVNode as l } from "vue";
const a = s("scan2"), i = /* @__PURE__ */ l("path", {
  d: "M802.595 1024H276.757C154.984 1024 55.35 924.368 55.35 802.595v-69.19c0-22.14 19.373-41.513 41.514-41.513s41.513 19.373 41.513 41.513v69.19c0 77.491 60.887 138.378 138.379 138.378h525.838c77.491 0 138.378-60.887 138.378-138.378v-66.422c0-22.14 19.373-41.514 41.513-41.514S1024 714.032 1024 736.173v66.422C1024 924.368 924.368 1024 802.595 1024zM96.865 332.108c-22.14 0-41.514-16.605-41.514-41.513v-69.19C55.351 99.632 154.984 0 276.757 0h525.838C924.368 0 1024 99.632 1024 221.405v69.19c0 22.14-19.373 41.513-41.514 41.513s-41.513-16.605-41.513-41.513v-69.19c0-77.491-60.887-138.378-138.378-138.378H276.757c-77.492 0-138.379 60.887-138.379 138.378v69.19c0 24.908-19.373 41.513-41.513 41.513zm940.973 221.406H41.514C19.373 553.514 0 534.14 0 512s19.373-41.514 41.514-41.514h996.324c22.14 0 41.513 19.373 41.513 41.514s-19.373 41.514-41.513 41.514z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, v, _, d, f, h) {
  return t(), c("svg", {
    class: n(e.classes),
    style: r(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1079 1024",
    role: "presentation"
  }, p, 6);
}
const w = /* @__PURE__ */ o(a, [["render", m]]);
export {
  w as default
};
